
export var isArray = Array.isArray || /* istanbul ignore next: fallback */function (value) {
    return Object.prototype.toString.call(value) === '[object Array]';
};

export var hasValue = function hasValue(value) {
    return typeof value !== 'undefined' && value !== null;
};

export var isFunction = function isFunction(value) {
    /* global window */
    return typeof window !== 'undefined' && value === window.alert || Object.prototype.toString.call(value) === '[object Function]';
};

export var isObject = function isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
};

export var isString = function isString(value) {
    return Object.prototype.toString.call(value) === '[object String]';
};

export var isSubClass = function isSubClass(B, A) {
    return B.prototype instanceof A || B === A;
};


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/typeChecks.js
// module id = 80
// module chunks = 0